import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class TicketOptionPartner extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    save(...args) {
        return this.constructor.save(this, ...args);
    }

    static save(objects, ...args) {
        let data = objects.toAPI();
        let url = this.getListUrl(...args);

        return fetcher.patch(url, { data });
    }

    static list(item) {
        return item;
    }

    static listUrl({ organizationId, eventId }) {
        if (!organizationId || !eventId) {
            throw new ArgumentError(`[Model][TicketOptionPartner] organizationId and eventId are mandatory`);
        }
        return `/ticket/organizations/${organizationId}/events/${eventId}/settings`;
    }
}
